<template>
	<div>
		<div class="section-gap primary pb-5">
			<v-container grid-list-xl pt-1>
				<v-layout row wrap align-center justify-center>
					<v-flex xs12 sm12 md6 lg6 xl6>
						<div class="subscribe-content">
							<h1 class="translate-right white--text">
								Personaliza el diseño de tus comprobantes emitidos desde el portal
								SOL/SUNAT
							</h1>
							<p class="translate-left white--text">
								Creado para empresas que emiten comprobantes desde el portal de
								sunat y quieren mejorar su imagen empresarial.
							</p>
							<v-btn color="accent" to="/planes" rounded>Comenzar ahora</v-btn>
							<!-- <v-btn color="warning" class="ml-2" href="http://demo.xsol.ml/" target="_new" rounded>Ver demo</v-btn> -->
						</div>
					</v-flex>
					<v-flex xs12 sm12 md6 lg6 xl6>
						<div class="subscribe-content">
							<div class="emb-aside-banner-v1 text-right">
								<img
									class="emb-card"
									alt="aside-banner"
									v-lazyload
									data-src="/static/images/custom-invoice.jpg"
									width="547"
									height="315"
								/>
							</div>
						</div>
					</v-flex>
				</v-layout>
			</v-container>
		</div>

		<v-container>
			<v-row>
				<v-col
					cols="12"
					xl="12"
					lg="12"
					md="12"
					sm="12"
					class="text-center"
					justify="center"
					align="center"
				>
					<h2 class="mt-8">Mejora tu imagen empresarial</h2>
					<p>
						Sislii te permite realizar tus ventas de manera rápida y sencilla. Todo esto
						gracias a su diseño intuitivo.
					</p>
					<img class="emb-card" v-lazyload data-src="/static/images/custom-invoice.jpg" />
				</v-col>
			</v-row>
		</v-container>
		<div class="section-gap primary lighten-5 pb-14">
			<v-container>
				<v-row class="text-center">
					<v-col cols="12" xl="12">
						<h3>¿Cómo funciona?</h3>
					</v-col>
					<v-col cols="12" xl="4" lg="4" md="6" sm="12">
						<div class="emb-card pa-4">
							<h6>1. Genera tu comprobante</h6>
							<p>
								Emite el comprobante desde el portal de sunat.
							</p>
						</div>
					</v-col>
					<v-col cols="12" xl="4" lg="4" md="6" sm="12">
						<div class="emb-card pa-4">
							<h6>2. Descarga el XML</h6>
							<p>
								Después de haber generado el comprobante descárgalo.
							</p>
						</div>
					</v-col>
					<v-col cols="12" xl="4" lg="4" md="6" sm="12">
						<div class="emb-card pa-4">
							<h6>3. Sube el XML descargado</h6>
							<p>
								Y por último sube el XML descargado sistema de Sislii ¡y listo.!
							</p>
						</div>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" xl="12" lg="12" md="12" sm="12" class="text-center">
						<img
							class="emb-card"
							alt="aside-banner"
							v-lazyload
							data-src="/static/images/steps-custom-invoice.jpg"
							width="800"
							height="315"
						/>
					</v-col>
				</v-row>
			</v-container>
		</div>
		<v-container>
			<v-row>
				<v-col cols="12" xl="12" lg="12" md="12" sm="12" class="text-center mt-14">
					<h4>¿Qué puedo personalizar?</h4>
					<p class="font-weight-bold">
						Ahora desde xSol y con un comprobante personalizado, podrás: descargar, imprimir y enviar por correo electrónico hacia tus clientes.
					</p>
				</v-col>
			</v-row>
            <v-row>
				<v-col
					cols="12"
					xl="8"
					lg="8"
					md="8"
					sm="12"
                    offset-xl="2"
                    offset-lg="2"
                    offset-md="2"
				>
					<v-card class="mx-auto" hover>
						<v-card-text class="text--primary">
							<div class="my-2 font-weight-medium">
								<v-icon left color="success">mdi-check</v-icon>
								Formato de impresión (A4 y/ó TICKET)
							</div>
							<v-divider></v-divider>
							<div class="my-2 font-weight-medium">
								<v-icon left color="success">mdi-check</v-icon>
								Logo
							</div>
							<v-divider></v-divider>
							<div class="my-2 font-weight-medium">
								<v-icon left color="success">mdi-check</v-icon>
								Dirección por sucursal
							</div>
							<v-divider></v-divider>
							<div class="my-2 font-weight-medium">
								<v-icon left color="success">mdi-check</v-icon>
								Teléfono
							</div>
							<v-divider></v-divider>
							<div class="my-2 font-weight-medium">
								<v-icon left color="success">mdi-check</v-icon>
								Correo electrónico
							</div>
							<v-divider></v-divider>
							<div class="my-2 font-weight-medium">
								<v-icon left color="success">mdi-check</v-icon>
								Sitio web
							</div>
							<v-divider></v-divider>
							<div class="my-2 font-weight-medium">
								<v-icon left color="success">mdi-check</v-icon>
								Slogan
							</div>
							<v-divider></v-divider>
							<div class="my-2 font-weight-medium">
								<v-icon left color="success">mdi-check</v-icon>
								Nombre comercial
							</div>
							<v-divider></v-divider>
							<div class="my-2 font-weight-medium">
								<v-icon left color="success">mdi-check</v-icon>
								Color de tu marca
							</div>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
			<v-layout row wrap white justify="center" align="center" class="mb-14">
				<v-flex xs12 sm12 md8 lg8 xl8>
					
				</v-flex>
			</v-layout>
		</v-container>
	</div>
</template>

<script>
import lazyload from 'Directives/lazyload';
export default {
	data() {
		return {
			type: false,
		};
	},
	directives: {
		lazyload,
	},
	beforeCreate() {
		document.title = 'Mejora tu diseño | Sislii';
	},
	methods: {
		scrollBy(hash) {
			document.querySelector(hash).scrollIntoView({
				block: 'start',
				behavior: 'smooth',
			});
		},
		detectOnline() {
			if (navigator.onLine) {
				alert('online');
			} else {
				alert('offline');
			}
		},
	},
};
</script>
